import { render, staticRenderFns } from "./PublicList.vue?vue&type=template&id=31e2c240&scoped=true&"
import script from "./PublicList.vue?vue&type=script&lang=js&"
export * from "./PublicList.vue?vue&type=script&lang=js&"
import style0 from "./PublicList.vue?vue&type=style&index=0&id=31e2c240&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31e2c240",
  null
  
)

export default component.exports